import { render, staticRenderFns } from "./BookEdit.vue?vue&type=template&id=35f5c6e2&scoped=true&"
import script from "./BookEdit.vue?vue&type=script&lang=js&"
export * from "./BookEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f5c6e2",
  null
  
)

export default component.exports